var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shipment-map-container"},[(_vm.isLoading)?_c('Loader',{attrs:{"is-loading":_vm.isLoading,"color":"blue","is-linear":""}}):(!_vm.origin && !_vm.destination && _vm.locations.length === 0)?_c('div',{staticClass:"no-data-message"},[_vm._v(" "+_vm._s(_vm.shipment.trackingRef || 'Shipment')+" has no locations ")]):_c('MapWithPopup',{attrs:{"locations":_vm.locations.map((location) => ({
      ...location,
      properties: {
        id: _vm.shipment.id,
        name: _vm.shipment.trackingRef,
        timestamp: location.timestamp,
        address: location.address,
      },
    })),"origin":_vm.origin,"destination":_vm.destination,"alerts":_vm.alerts,"has-more-locations":_vm.isMoreData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }